import React, {useState} from 'react';
import './QuizParagraphSpan.css';

const QuizParagraphSpan = props => {
	const [classes, setClasses] = useState('quiz-para-animation-mask');
	const animationStyle = {
		transition: `width ${props.duration}s`,
		backgroundColor: props.textBGColor,
		border: `none`
	}

	setTimeout(() => { setClasses('quiz-para-animation-mask hide-mask') }, props.delay * 1000)

	return (
		<div className={'quiz-para-container'} style={{ backgroundColor: props.textBGColor }}>
			<span className={'quiz-para-span'}>{props.spanText}</span>
			<span className={classes} style={animationStyle} />
		</div>
	);
};

export default QuizParagraphSpan;